type GetEncumbranceDetailsPathParams = {
  societyId: string;
  partnerId: string;
  encumbranceId: string;
  shareId?: string | null | { _id?: string };
};

const resolveShareId = (
  shareId?: string | null | { _id?: string }
): string | undefined => {
  if (!shareId) {
    return undefined;
  }

  if (typeof shareId === 'string') {
    return shareId;
  }

  return shareId._id;
};

export const getEncumbranceDetailsPath = ({
  societyId,
  partnerId,
  encumbranceId,
  shareId,
}: GetEncumbranceDetailsPathParams): string => {
  const resolvedShareId = resolveShareId(shareId);

  if (resolvedShareId) {
    return `/detalle-carga/${societyId}/${partnerId}/${resolvedShareId}/${encumbranceId}`;
  }

  return `/detalle-carga/${societyId}/${partnerId}/${encumbranceId}`;
};
